import { AxiosInstance } from "axios";
import axiosHelper from "../axiosHelper";
import VehicleModel from "@/models/VehicleModel";

export default class VehicleModelsApiHelper {

	_url: string = '/api/vehiclemodels';
	_httpClient!: AxiosInstance;

	constructor(jwt: string) {
		this._httpClient = axiosHelper.createInstance(jwt);
	}

	async isAlreadyExistAsync(vehicleModelName: string, vehicleManufacurerId: number, exceptVehicleModelId?: number) : Promise<boolean | null> {
		try {
			const request = {
				modelName: vehicleModelName,
				manufacturerId: vehicleManufacurerId,
				exceptVehicleModelId
			};
			const response = await this._httpClient.post<boolean>(`${this._url}/exist`, request);		
			if (!response.data === null) {
				console.error('Unable to check vehicle model: empty response');
				return null;
			}
			return response.data;
		} catch(e: any) {
			console.error(`Unable to check vehicle model existence '${vehicleModelName}'`, e);
			return null;
		}
	}

	async isDeletableAsync(vehicleId: number) : Promise<boolean | null> {
		try {
			const response = await this._httpClient.get<boolean>(`${this._url}/deletable/${vehicleId}`);
			if (!response.data === null) {
				console.error('Unable to check vehicle model: empty response');
				return null;
			}
			return response.data;
		} catch(e: any) {
			console.error(`Unable to check whether vehicle deletable #${vehicleId}`, e);
			return null;
		}
	}

	async getModelsAsync(tableSortColumn: string, 
		tableSortDir: string,
		query: string | null,
		brands: Array<number> | null) : Promise<Array<VehicleModel> | null> {
		try {
			const filterObject = {
				orderBy: tableSortColumn,
				orderAsc: tableSortDir == 'ascending',
				query,
				brands: brands ? brands.join(',') : null
			};

			const response = await this._httpClient.get(`${this._url}`, { params: filterObject });
			if (!response.data?.length) {
				return [];
			}
			return response.data.map((_: any) => new VehicleModel(_));
		} catch(e) {
			console.error(`Unable to load list of vehicle models`, e);
			return null;
		}
	}

	async createAsync(request: VehicleModel) : Promise<VehicleModel | null> {
		try {
			const response = await this._httpClient.post(this._url, request);		
			if (!response.data?.id) {
				console.error('Unable to create vehicle model: empty response');
				return null;
			}
			return new VehicleModel(response.data);			
		} catch(e: any) {
			if (e?.status === 409) {
				console.error(`Unable to create vehicle model: model '${request.name}' already exists`);
				return null;
			}

			console.error('Unable to create vehicle model', e);
			return null;
		}
	}

	async updateAsync(request: VehicleModel) : Promise<VehicleModel | null> {
		try {			
			const response = await this._httpClient.put(this._url, request);		
			if (!response.data?.id) {
				console.error('Unable to update vehicle model: empty response');
				return null;
			}
			return new VehicleModel(response.data);
		} catch(e: any) {
			if (e?.status === 409) {
				console.error(`Unable to update vehicle model #${request.id}: model '${request.name}' already exists`);
				return null;
			}

			console.error('Unable to update vehicle model', e);
			return null;
		}
	}

	async getModelByIdAsync(id: number) : Promise<VehicleModel | null>  {
		try {			
			const respone = await this._httpClient.get(`${this._url}/${id}`);	
			if (!respone.data?.id) {
				return null;
			}
			return new VehicleModel(respone.data);
		} catch(e) {
			console.error(`Unable to get vehicle model by id #${id}`, e);
			return null;
		}
	}

	async deleteAsync(vehicleId: number) : Promise<boolean> {
		try {
			await this._httpClient.delete(`${this._url}/${vehicleId}`);
			return true;
		} catch(e: any) {
			if (e?.status === 409) {
				return false;
			}
			console.error(`Unable to delete vehicle model #${vehicleId}`, e);
			return false;
		}
	}
}
